import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import APIS from "@service/api";
import { getUser } from "@utils";

export const riskManagementApi = createApi({
	reducerPath: "riskManagementApi",
	refetchOnFocus: false,
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: false,
	baseQuery: fetchBaseQuery({
		baseUrl: APIS["riskmanagement-api"],
		prepareHeaders: (headers) => {
			const user = getUser();

			if (user?.token) {
				headers.set("Authorization", `Bearer=${user.token}`);
			}

			if (window.TENANT) {
				headers.set("tenant", window.TENANT);
			}

			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		postGeoloc: builder.mutation({
			query: ({ responseVault }) => ({
				url: "geoloc",
				method: "POST",
				body: { responseVault },
			}),
		}),
		getGeoloc: builder.query({
			query: () => ({
				url: "geoloc",
				method: "GET",
			}),
		}),
	}),
});

export const { usePostGeolocMutation, useGetGeolocQuery } = riskManagementApi;
